"use client";

import { Menu } from "@/lib/shopify/types";
import { cn } from "@/utils/cn";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";
import { AuthNavLinks } from "./navbar/auth-nav";

export function FooterMenuItem({ item }: { item: Menu }) {
  const pathname = usePathname();
  const [active, setActive] = useState(pathname === item.path);

  useEffect(() => {
    setActive(pathname === item.path);
  }, [pathname, item.path]);

  return (
    <li>
      <Link
        href={item.path}
        className={cn(
          "lock text-sm text-accent underline-offset-4 hover:underline md:inline-block md:p-2 md:text-lg xl:text-2xl",
          {
            "text-accent": active,
          },
        )}
      >
        {item.title}
      </Link>
    </li>
  );
}

export default function FooterMenu({ menu }: { menu: Menu[] }) {
  if (!menu.length) return null;

  return (
    <>
      <nav className="hidden w-full border-t-1 border-b-1 border-accent md:block">
        <ul className="mx-auto flex max-w-[1600px] justify-between px-10 py-3 font-mono uppercase lg:px-32">
          {menu.map((item: Menu) => {
            return <FooterMenuItem key={item.title} item={item} />;
          })}
          <AuthNavLinks style="lock cursor-pointer text-sm text-accent underline-offset-4 hover:underline md:inline-block md:p-2 md:text-lg xl:text-2xl text-accent"></AuthNavLinks>
        </ul>
      </nav>
      <nav className="block w-full font-mono text-sm uppercase md:hidden">
        <div className="flex justify-center gap-10 border-y-2 border-accent py-5">
          <Link href="/">home</Link>
          <Link href="/search">shop</Link>
          <Link href="/about">about us</Link>
        </div>
        <div className="flex justify-center gap-10 border-b-2 border-accent py-5">
          <Link href="/contact">contact us</Link>
          <AuthNavLinks style="list-none lock cursor-pointer text-sm text-accent md:inline-block md:p-2 md:text-lg xl:text-2xl text-accent"></AuthNavLinks>
        </div>
      </nav>
    </>
  );
}
